// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".business-search__input[data-v-2cf2931a]{height:40px;width:-moz-min-content;width:min-content}.business-search__result-item[data-v-2cf2931a]{color:#000!important}.business-search__result-item[data-v-2cf2931a]:hover{color:#3b54ab!important}.business-search__result-loading[data-v-2cf2931a]{max-height:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
